
export const getDTMInit = (pageInfo, category = "", productName = "", addToCart = "", paymentOption = "", stateInfo = "", categoryName = "", currentlySelected = "",transactionData = {}, referringUrl = "") => {
    let initData = scDataDetails[pageInfo];

    /*if (category !== "") {        
        initData.detailPageName = initData.detailPageName + "| " + category.toLowerCase() + "| " +productName.toLowerCase();
    }*/
    if (category !== "") {
        var catExisting = initData.detailPageName.indexOf(category);
        var categoryPageName = "accessories| categories| ";
        var categoryDetailPageName = "accessories| categories ";
        var pdpPageName = "accessories| pdp| ";
        if (catExisting === -1) {
            if (initData.detailPageName === 'accessories| categories') {
                initData.detailPageName = initData.detailPageName + "| " + category.toLowerCase();
            } else if (((initData.detailPageName.indexOf('accessories| pdp| ') || (initData.detailPageName.indexOf('accessories| view cart ')) || (initData.detailPageName.indexOf('accessories| shipping information ')) || (initData.detailPageName.indexOf('accessories| billing information ')) || (initData.detailPageName.indexOf('accessories| begin checkout ')) || (initData.detailPageName.indexOf('accessories| order review ')) || (initData.detailPageName.indexOf('accessories| order confirmation '))) && (productName === ''))) {
                initData.detailPageName = '';
                initData.detailPageName = categoryPageName + category.toLowerCase();
            } else {
                initData.detailPageName = pdpPageName + category.toLowerCase() + "| " + productName.toLowerCase();
            }

        } else {
            initData.detailPageName = '';
            initData.detailPageName = pdpPageName + category.toLowerCase() + "| " + productName.toLowerCase();
        }
    }
    if (pageInfo === "accessoriesPdpCategories" || pageInfo === "featuredAccessories" || pageInfo === "othersViewedAccessories") {
        if ((initData.pageName === 'accessories| pdp| ') && category !== '') {
            initData.pageName = '';
            initData.pageName = categoryDetailPageName;
        } else {
            initData.pageName = pdpPageName + category.toLowerCase();
        }
    }
    let device = "eaccessories";
    let dtmtmpurl = window.location.href.toLowerCase();
    let pagetype = "learn";
    let flowName = "learn| accessory";
    let scUserProfileData = {
        "loginStatus": "anonymous", "customerType": "", "appSessionID": "", "verizonUID": "unauthenticated"

    }
    let sctransactionData = { "MON": "", "orderPayMethod": "", "purchaseID": "", "transactionID": "" }
    let addrProfile = { "serviceStateProvince": "", "serviceCountry": "", "servicePostalCode": "" }

    if (dtmtmpurl.indexOf('/clu') !== -1) {
        device = 1 === /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()) ? "eaccessories - mobile" : /Tablet|iPad/i.test(navigator.userAgent.toLowerCase()) ? "eaccessories tablet" : "eaccessories";
    }
    else if (dtmtmpurl.indexOf('/accessories') !== -1) {
        if (/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) {
            device = "eaccessories mobile"
        } else if (/Tablet|iPad/i.test(navigator.userAgent.toLowerCase())) {
            device = "eaccessories tablet"
        }
    }

    let adobesuite = -1 !== dtmtmpurl.indexOf("/clu") ? (document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal,verizontelecomres" : "verizontelecomglobaldev,verizontelecomresdev") : (document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal,verizontelecomres" : "verizontelecomglobaldev,verizontelecomresdev");

    if (dtmtmpurl.indexOf("/accessories") !== -1) {
        adobesuite = document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal" : "verizontelecomglobaldev";
    }
    if (dtmtmpurl.indexOf("/checkout") !== -1 || addToCart === true || dtmtmpurl.indexOf("/begincheckout") !== -1 || dtmtmpurl.indexOf("/shoppingcart") !== -1) {
        pagetype = "order"
        flowName = "order| accessory";
    }
    else {
        pagetype = "learn"
    }

    if (paymentOption !== "") {
        if (paymentOption === "showBillToAccount") {
            sctransactionData.orderPayMethod = "bill to account";
        }
        else {
            sctransactionData.orderPayMethod = "pay with saved card";
        }
    }

    let userinfo = "";
    if (document.cookie && document.cookie.split(";").length > 0) {
        userinfo = document.cookie.split(";").find(val => val.indexOf('userinfo') !== -1)
        userinfo = userinfo && userinfo.split('userinfo=')[1]
    }

    if (userinfo !== undefined && userinfo !== "" && pagetype !== "learn") {
        flowName = flowName + " ec"
        pagetype = pagetype + " ec"
    }
    if (userinfo !== undefined && userinfo !== "") {
        scUserProfileData.verizonUID = "authenticated";
        scUserProfileData.loginStatus = "logged in"
    }

    if(transactionData){
        scUserProfileData.appSessionID = (transactionData.visitId === undefined || transactionData.visitId === "") ? "" : transactionData.visitId;
        sctransactionData.transactionID = (transactionData.visitId === undefined || transactionData.visitId === "") ? "" : transactionData.visitId;
        sctransactionData.purchaseID = (transactionData.visitId === undefined || transactionData.visitId === "") ? "" : transactionData.visitId;
        addrProfile.serviceStateProvince = (transactionData.state === undefined || transactionData.state === "") ? "" : transactionData.state;
        addrProfile.serviceCountry = (transactionData.city === undefined || transactionData.city === "") ? "" : transactionData.city; 
        addrProfile.servicePostalCode = (transactionData.zipcode === undefined || transactionData.zipcode === "") ? "" : transactionData.zipcode; 
        sctransactionData.MON = (transactionData.mon === undefined || transactionData.mon === "") ? "" : transactionData.mon; 

    }
    // if (stateInfo && stateInfo !== undefined && stateInfo !== "") {
    //     if (stateInfo.shippingInfo && stateInfo.shippingInfo.monValue && stateInfo.shippingInfo.monValue.mon !== "") {
    //         sctransactionData.MON = stateInfo.shippingInfo.monValue.mon;
    //     }
    //     if (stateInfo.shippingInfo && stateInfo.shippingInfo.personalInfo && stateInfo.shippingInfo.personalInfo !== "") {
    //         addrProfile.serviceStateProvince = stateInfo.shippingInfo.personalInfo.state;
    //         addrProfile.serviceCountry = stateInfo.shippingInfo.personalInfo.city;
    //         addrProfile.servicePostalCode = stateInfo.shippingInfo.personalInfo.zipcode;
    //     }
    //     if (stateInfo.visitId && stateInfo.visitId !== "") {
    //         sctransactionData.transactionID = stateInfo.visitId;
    //         sctransactionData.purchaseID = stateInfo.visitId;
    //     }
    // }

    let scPageData = {}
    scPageData = {
        "sysEnv": document.domain.indexOf("www.verizon.com") !== -1 ? "prod" : "dev",
        "adobeReportSuite": adobesuite,
        "language": "en_US",
        "pfxID": "shp",
        "pageName": initData.pageName,
        "detailPageName": initData.detailPageName,
        "pageType": pagetype,
        "lineOfBusiness": "business",
        "businessUnit": "small business",
        "cmsPlatform": "shpATG",
        "applicationName": device,
        "events": initData.events,
        "offerIDClicked": "",
        "flowName": flowName,
        "applicationType": "Inhome -  Accessories",
        "referringURL":referringUrl
    }

    let newEvent = {
        "page": scPageData,
        "userProfile": scUserProfileData,
        "addrProfile": addrProfile,
        "cart": "",
        "transaction": sctransactionData,
        "product": []
    }

    window.digitalData = newEvent;

    let newPageViewEvent = {
        eventInfo: { eventName: "pageViewUpdate", timeStamp: new Date(), processed: { adobeAnalytics: false } },
        scEvents: initData.events,
        product: []
    };
    let prdArray = [];
    if (stateInfo && stateInfo !== "" && stateInfo.cartProduct && stateInfo.cartProduct.length > 0) {
        prdArray = getProductObject(stateInfo);
        if (addToCart) {
            if (prdArray.length > 1) {
                for (var i = 0; i < prdArray.length; i++) {
                    if (currentlySelected === prdArray[i].productName) {
                        newPageViewEvent.product[0] = prdArray[i]
                    }
                }
            } else {
                newPageViewEvent.product[0] = prdArray[0];
            }
        } else {
            newPageViewEvent.product = prdArray;
        }
    } else if (stateInfo && stateInfo !== "") {
        prdArray = getProductObject(stateInfo);
        if (addToCart) {
            if (prdArray.length > 1) {
                for (var i = 0; i < prdArray.length; i++) {
                    if (currentlySelected === prdArray[i].productName) {
                        newPageViewEvent.product[0] = prdArray[i]
                    }
                }
            } else {
                newPageViewEvent.product[0] = prdArray[0];
            }

        } else {
            newPageViewEvent.product = prdArray;
        }
    }
    window.digitalData = window.digitalData || {};
    window.digitalData.events = window.digitalData.events || [];
    window.digitalData.events.push(newPageViewEvent);
    sendCustomEvent("pageViewUpdate");
}

var retrySendCustomEventCount = 0;


export const tempSCData = {
    pageName: "",
    detailPageName: "",
    contentChannel: "",
    events: "",
    statePostLQA: "",
    servicePostalCode: "",
    flowName: "",
    bundleSelected: "",
    product: [],
    depositAmount: "",
    installOptions: "",
    MON: "",
    serviceDMA: "",
    newnewRepeatXP1: "",
    creditCheck: "",
    creditCheckstatus: "",
    customerCategory: "",
    isMixMatch: false,
    profileProduct: [],
    IONTEligible: false,
    isSUPPflow: false
};

export const scDataDetails = {
    checkoutShipping: { pageName: "accessories| shipping information", detailPageName: "accessories| shipping information", events: "event5,event13,event14,scCheckout" },
    checkoutBilling: { pageName: "accessories| billing information", detailPageName: "accessories| billing information", events: "event5,event13" },
    beginCheckout: { pageName: "accessories| begin checkout", detailPageName: "accessories| begin checkout", events: "event5" },
    viewCart: { pageName: "accessories| view cart", detailPageName: "accessories| view cart", events: "event5,prodView,scView,event22" },
    addToCart: { pageName: "accessories| pdp| add to cart", detailPageName: "accessories| pdp| add to cart", events: "event5,prodView,scAdd,scOpen" },
    addToCartHome:{ pageName: "accessories| home| add to cart",detailPageName: "accessories| home| add to cart", events: "event5,prodView,scAdd,scOpen" },
    addToCartProdlist:{ pageName: "accessories| categories| add to cart",detailPageName: "accessories| categories| add to cart", events: "event5,prodView,scAdd,scOpen" },
    orderReview: { pageName: "accessories| order review", detailPageName: "accessories| order review", events: "event46,event5" },
    orderReviewExpress: { pageName: "accessories| order review", detailPageName: "accessories| express| order review", events: "event5,event13,event14,event46,scCheckout" },
    orderConfirmation: { pageName: "accessories| order confirmation", detailPageName: "accessories| order confirmation", events: "event5,event40,event42,event43,event44,event55,event70,purchase" },
    accessoriesHome: { pageName: "accessories home", detailPageName: "accessories| home", events: "event3" },
    accessoriesCategories: { pageName: "accessories| categories", detailPageName: "accessories| categories", events: "event3" },
    accessoriesPdpCategories: { pageName: "accessories| pdp", detailPageName: "accessories| pdp", events: "event5,event12,prodView" },
    featuredAccessories: { pageName: "accessories| pdp", detailPageName: "accessories| pdp", events: "event5,event12,prodView" },
    othersViewedAccessories: { pageName: "accessories| pdp", detailPageName: "accessories| pdp", events: "event5,event12,prodView" }
}


export const getProductObject = (stateInfo) => {
    let prdArray = []
    try {
        let cartProduct = "";
        if (stateInfo.cartProduct && stateInfo.cartProduct !== "") {
            cartProduct = stateInfo.cartProduct;
        } else {
            cartProduct = stateInfo;
        }
        cartProduct.map(obj => {
            prdArray.push(getPrdArrayFromCart(obj))
        })
    }
    catch (error) {
        console.log(error)
    }
    return prdArray;
}

const getPrdArrayFromCart = (obj) => {
    return ({
        "discountID": "",
        "priceBase": (obj && obj.qty && Math.round(obj.price * obj.qty * 100) / 100).toString(),
        "priceDiscount": "0",
        "priceNonRecurring": (obj && obj.qty && obj.price === obj.discountPrice ? Math.round(obj.price * obj.qty * 100) / 100 : Math.round(obj.discountPrice * obj.qty * 100) / 100).toString(),
        "priceRecurring": "0.00",
        "priceShipping": "0.0",
        "priceTax": "0.0",
        "primaryCategoryandSub": obj.categoryName,
        "productID": obj.name,
        "productName": obj.itemName,
        "quantity": obj.qty
    })
}

const sendCustomEvent = (evt) => {
    retrySendCustomEventCount = 0;
    if (window.dtm_doplugins) {
        if (document.createEvent && document.body.dispatchEvent) {
            var event = document.createEvent('Event');
            event.initEvent(evt, true, true);
            document.body.dispatchEvent(event);
        } else if (window.CustomEvent && document.body.dispatchEvent) {
            var ev = new CustomEvent(evt, {
                bubbles: true,
                cancelable: true
            });
            document.body.dispatchEvent(ev);
        }
    }
    else {
        setTimeout(() => { retrySendCustomEvent(evt); }, 5000);
    }
}


const retrySendCustomEvent = (evt) => {
    retrySendCustomEventCount = retrySendCustomEventCount++;
    if (window.dtm_doplugins) {
        sendCustomEvent(evt);
    } else if (retrySendCustomEventCount < 5) {
        setTimeout(() => { retrySendCustomEvent(evt); }, 1500);
    }
}

export const updateSCTags = (linkName) => {
    try {
        window.scLinkTrackID && window.scLinkTrackID(linkName);
    } catch (err) {
        console.log(err);
    }
}

export const addToCartSCEvent = (visitId, product, prodType, response, isDoFlow, isPrdAddEvent, upsellInfo = null, flowType, isFCPflow) => {


}



export const scClickEventProduct = (product, prodType) => {

}



